import { Table, TableBody, TableHead, TableHeader, TableRow, TableCell } from "@/components/ui/table.jsx";
import { Skeleton } from "@/components/ui/skeleton.jsx";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

const ROW_COUNT = 10;

const SecretShopperReportSkeleton = () => {
    return (
        <div className="w-full max-w-7xl mx-auto mt-6">
            <div className="flex justify-between items-center mb-8">
                <h2 className="text-3xl font-semibold text-slate-900">Secret Shops</h2>
                <Button disabled className="justify-between min-w-[200px]">
                    <Plus className="mr-2 h-4 w-4" />
                    Create Secret Shop
                </Button>
            </div>

            <div className="rounded-md border">
                <Table>
                    <TableHeader>
                        <TableRow className="h-20">
                            <TableHead />
                            <TableHead>Community</TableHead>
                            <TableHead>Created Date</TableHead>
                            <TableHead className="text-center">Call</TableHead>
                            <TableHead className="text-center">Text</TableHead>
                            <TableHead className="text-center">Email</TableHead>
                            <TableHead className="text-center">Voicemail</TableHead>
                            <TableHead className="text-center">Status</TableHead>
                        </TableRow>
                    </TableHeader>

                    <TableBody>
                        {Array.from({ length: ROW_COUNT }).map((_, idx) => (
                            <TableRow key={idx} className="h-20">
                                <TableCell className="text-center">
                                    <Skeleton className="h-4 w-4 mx-auto" />
                                </TableCell>
                                <TableCell>
                                    <Skeleton className="h-4 w-32" />
                                </TableCell>
                                <TableCell>
                                    <Skeleton className="h-4 w-24" />
                                </TableCell>
                                {[...Array(4)].map((_, iconIdx) => (
                                    <TableCell key={iconIdx} className="text-center">
                                        <Skeleton className="h-4 w-4 mx-auto" />
                                    </TableCell>
                                ))}
                                <TableCell className="text-center">
                                    <Skeleton className="h-5 w-16 rounded-full mx-auto" />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
};

export default SecretShopperReportSkeleton;
